import type { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * PageContainer - Provides consistent layout wrapper for all pages in the app
 * Ensures uniform spacing, background, and responsive padding across all pages
 */
export function PageContainer({
  children,
  className = "",
}: PageContainerProps) {
  return (
    <div className={`min-h-screen bg-bgWhite px-4 py-6 sm:p-6 ${className}`}>
      {children}
    </div>
  );
}
